import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { cartService } from "./services/cartServise";
import { Locations } from "../components/CartsLocationMap";


interface CartState {
  carts: any;
  loading: boolean;
  error: string | null;
  selectedCart: Locations | null;
}

const initialState: CartState = {
  carts: [],
  loading: false,
  error: null,
  selectedCart: null,
};

const cartSlice = createSlice({
  name: "carts",
  initialState,
  reducers: {
    getCartListStart(state) {
      state.loading = true;
      state.error = null;
    },
    getCartListSuccess(state, action) {
      state.carts = action.payload;
      state.loading = false;
    },
    getCartListFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setSavedSelectedCart(state, action: PayloadAction<Locations | null>) {
      state.selectedCart = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      cartService.endpoints.getCartListByRestaurantId.matchFulfilled,
      (state, { payload }) => {
        state.carts = payload.carts;
        state.loading = false;
        state.error = null;
      }
    );
  },
});

export const {
  getCartListStart,
  getCartListSuccess,
  getCartListFailure,
  setSavedSelectedCart,
} = cartSlice.actions;

// export const selectCartList = (state: RootState) => state.cartList;
// export const selectCartListLoading = (state: RootState) => state.cartList;
// export const selectCartListError = (state: RootState) => state.cartList;

export default cartSlice.reducer;
